var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-setting global-page-base-layout" },
    [
      _c(
        "div",
        { staticClass: "add-doc" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.gotoCreate } },
            [_vm._v("添加会议硬件设备")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple-light" },
                [
                  _vm._v("\n          所属仲裁委：\n          "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { size: "medium", placeholder: "请选择" },
                      model: {
                        value: _vm.committeeValue,
                        callback: function ($$v) {
                          _vm.committeeValue = $$v
                        },
                        expression: "committeeValue",
                      },
                    },
                    _vm._l(_vm.committeeArr, function (item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "select-conditions-row",
            staticStyle: { "text-indent": "5em", "margin-top": "25px" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "medium" },
                on: { click: _vm.screen },
              },
              [_vm._v("筛选")]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "clear-all", on: { click: _vm.clearAllConditon } },
              [_vm._v("清空筛选条件")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "设备名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "commName", label: "仲裁委名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "serverSupport", label: "渠道" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.channelType[scope.row.serverSupport]) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "code", label: "设备号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "password", label: "设备密码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "会议设备编辑",
            visible: _vm.sourceVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sourceVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "temForm",
              attrs: {
                model: _vm.temForm,
                "label-position": "left",
                "label-width": "120px",
                rules: _vm.temFormRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设备名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { type: "text", placeholder: "请填写会议通道名称" },
                    model: {
                      value: _vm.temForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.temForm, "name", $$v)
                      },
                      expression: "temForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "归属仲裁委", prop: "commId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { size: "medium", placeholder: "请选择仲裁委" },
                      model: {
                        value: _vm.temForm.commId,
                        callback: function ($$v) {
                          _vm.$set(_vm.temForm, "commId", $$v)
                        },
                        expression: "temForm.commId",
                      },
                    },
                    _vm._l(_vm.committeeArr, function (item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "渠道类型", prop: "serverSupport" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { size: "medium", placeholder: "请选择渠道类型" },
                      model: {
                        value: _vm.temForm.serverSupport,
                        callback: function ($$v) {
                          _vm.$set(_vm.temForm, "serverSupport", $$v)
                        },
                        expression: "temForm.serverSupport",
                      },
                    },
                    _vm._l(_vm.typeArr, function (item, index) {
                      return _c("el-option", {
                        key: item.status,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设备号", prop: "code" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { type: "text", placeholder: "请填写会议号" },
                    model: {
                      value: _vm.temForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.temForm, "code", $$v)
                      },
                      expression: "temForm.code",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设备密码", prop: "password" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { type: "password", placeholder: "请填写会控密码" },
                    model: {
                      value: _vm.temForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.temForm, "password", $$v)
                      },
                      expression: "temForm.password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sourceVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("temForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }